import React from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, useTheme } from '@mui/material';

import { Icon, useSettings } from 'app/main/components';
import { toggleLastActionsPanel } from './store/stateSlice';

function QuickPanelToggleButton() {
	const dispatch = useDispatch();
	const theme = useTheme();
	const { t } = useSettings();

	return (
		<Tooltip title={t('RECENT_ACTIVITY_TITLE')} arrow>
			<IconButton className="h-40 w-40" onClick={ev => dispatch(toggleLastActionsPanel())}>
				<Icon icon="timetable" color="primary.contrastText" />
			</IconButton>
		</Tooltip>
	);
}

export default QuickPanelToggleButton;
